module.exports = __webpack_public_path__ + "static/media/wave.26378914.png";